import { api } from './index';

export interface DashboardStats {
  totalApartments: number;
  totalResidents: number;
  totalStaff: number;
  totalTasks: number;
  pendingTasks: number;
  completedTasks: number;
  totalFeedbacks: number;
  pendingFeedbacks: number;
  completedFeedbacks: number;
  totalBookings: number;
  pendingBookings: number;
  completedBookings: number;
  totalBills: number;
  paidBills: number;
  unpaidBills: number;
  overdueBills: number;
  totalRevenue: number;
  monthlyRevenue: number;
  totalChatMessages: number;
  unreadChatMessages: number;
}

export interface RecentActivity {
  id: string;
  type: 'task' | 'feedback' | 'booking' | 'payment' | 'chat' | 'construction';
  title: string;
  description: string;
  timestamp: string;
  status: string;
  userId: string;
  userName: string;
}

export interface TaskSummary {
  id: string;
  title: string;
  status: string;
  priority: string;
  assignedTo: string;
  dueDate: string;
  createdAt: string;
}

export interface FeedbackSummary {
  id: string;
  title: string;
  category: string;
  status: string;
  priority: string;
  createdAt: string;
  apartmentCode: string;
}

export interface BookingSummary {
  id: string;
  utilityName: string;
  status: string;
  startTime: string;
  endTime: string;
  apartmentCode: string;
  totalAmount: number;
}

export interface RevenueData {
  month: string;
  revenue: number;
  bills: number;
  payments: number;
}

export interface DashboardData {
  stats: DashboardStats;
  recentActivities: RecentActivity[];
  recentTasks: TaskSummary[];
  recentFeedbacks: FeedbackSummary[];
  recentBookings: BookingSummary[];
  revenueData: RevenueData[];
}

class DashboardApi {
  async getDashboardData(): Promise<DashboardData> {
    const response = await api.get('/dashboard');
    return response.data;
  }

  async getStats(): Promise<DashboardStats> {
    const response = await api.get('/dashboard/stats');
    return response.data;
  }

  async getRecentActivities(limit: number = 10): Promise<RecentActivity[]> {
    const response = await api.get(`/dashboard/activities?limit=${limit}`);
    return response.data;
  }

  async getRevenueData(months: number = 12): Promise<RevenueData[]> {
    const response = await api.get(`/dashboard/revenue?months=${months}`);
    return response.data;
  }
}

export const dashboardApi = new DashboardApi(); 